import type { ReactNode } from 'react';
import { NeonModalDialog } from '@ps-refarch-ux/neon';
import { useDomId } from '../hooks/useDomId';

export type ModalSize = 'x-small' | 'small' | 'medium' | 'large' | 'x-large' | 'max';

export interface ModalProps {
  title: string;
  onClose: () => void;
  footer?: ReactNode;
  children: ReactNode;
  size?: ModalSize;
}

/**
 * Neon modal dialog. Mounting opens it; the user closing it (X / backdrop)
 * fires `onClose`. Content is placed into Neon's header/body/footer slots.
 */
export function Modal({ title, onClose, footer, children, size = 'medium' }: ModalProps) {
  const id = useDomId('modal');
  return (
    <NeonModalDialog
      id={id}
      dataSize={size}
      dataShowCloseButton="true"
      dataCloseOnBackdropClick="true"
      neonDialogHasClosed={onClose}
    >
      <div data-slot="dialog-header-title">{title}</div>
      <div data-slot="dialog-body">{children}</div>
      {footer ? <div data-slot="dialog-button-footer">{footer}</div> : null}
    </NeonModalDialog>
  );
}
